/*
 * @Description: 优惠券列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-06-28 10:04:15
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import {Divider, message, Popconfirm} from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import {postFrom, config, post} from '../../axios';
import {formatTime, moneyAddComma} from '../../utils/index'
import { dicHouseStatus, dicPayType, hsbPayChannelStatus} from '../../axios/dictionaries';
 import ListAdd from './components/ListAdd';
import {
    API_wftPayChannel_findPageList, API_wftPayChannel_updateWftPayChannelConfigStatus
} from "../../axios/config";
import ActionRecords from "../ActionRecords";

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',          //关键字
                pageSize: 10,
                payType:'',
                mustPayDate:''
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //显示新增/编辑
            actionVisible:false
        }
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
            actionVisible
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="j-8-1" type="primary" icon="plus" onClick={() => { this.setState({ showAddModal: true }); this.ListAddRef.initPack(); }}>支付渠道新增</AuthButton>
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ handleEdit: this.handleEdit,handleEditStatus:this.handleEditStatus,handleQueryActionRecords:this.handleQueryActionRecords })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
                <ListAdd
                    onRef={ref => this.ListAddRef = ref}
                    visible={showAddModal}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                    handleGetList={this.handleSearch}
                />
                <ActionRecords
                    onRef={ref => this.onAction = ref}
                    visible={actionVisible}
                    handleCancel={() => { this.setState({ actionVisible: false }) }}
                />

            </PageWrap>
        )
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_wftPayChannel_findPageList, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleQueryActionRecords = (id) => { //操作日志
        this.setState({ actionVisible: true });
        this.onAction.queryActionRecords({ rowId:id, tableName: "wftPayChannelConfig" });
    }

    handleEdit = (id) => { //编辑
        this.setState({ showAddModal: true });
        this.ListAddRef.loadPack({ id });
        this.ListAddRef.initPack();
    }
    handleEditStatus=(id,status) =>{


        post({ url: config.API_wftPayChannel_updateWftPayChannelConfigStatus, data: { status, id } }).then(res => {
            message.success('操作成功');
            this.handleSearch();
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }
}

const searchData = () => [

    {
        tagName: 'Select',
        formConfig: { name: 'status' },
        attribute: { placeholder: '请选择支付渠道状态', style: { width: '160px' } },
        optionData: [{ title: '全部', value: '' }].concat(hsbPayChannelStatus),
        notResult: '',
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'shortName' },
        attribute: { placeholder: '输入商户名称', style: { width: '160px' } },
        title: '查询商户名称及简称模糊查询'
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字', style: { width: '160px' } },
        title: '在支付渠道名称内模糊查询'
    },

];

const columns = ({ handleEdit , handleEditStatus,handleQueryActionRecords}) => [
    {
        title: '商户简称',
        dataIndex: 'shortName',
    },
    {
        title: '名称',
        dataIndex: 'projectName',
    },
    {
        title: '支付渠道状态',
        dataIndex: 'status',
        render(text){
            if(text){
                let now = hsbPayChannelStatus.find(item => item.value === text);
                if (now)
                    return <span>{now.title}</span>;
            }else{
                return "";
            }
        }
    },
    {
        title: '威富通商户号',
        dataIndex: 'mchId',
    },
    {
        title: '签名方式',
        dataIndex: 'signType',
    },
    {
        title: '是否分账',
        dataIndex: 'splitAccount',
        render(text){
            if(text){
                if (text==1){
                    return <span>分账</span>;
                }else{
                    return <span>不分账</span>;
                }
            }else{
                return "";
            }
        }
    },
    {
        title: '更新时间',
        dataIndex: 'updateTime',
        render(text) {
            if (!text) return '-'
            return formatTime(text)
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 200,
        render(text, record, index) {
            return (
                <React.Fragment>
                <AuthButton authkey="j-5-2">
                    <span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span>
                    <Divider type="vertical" />
                </AuthButton>
                <AuthButton authkey="j-5-3">
                    <Popconfirm
                        placement="topRight"
                        title={record.status===2?'此支付渠道确认启用吗?':'此支付渠道确认禁用吗?如果禁用该支付渠道下的房源将不会使用该支付渠道!'}
                        onConfirm={() => {

                            handleEditStatus(record.id, record.status===2?1:2);
                        }}
                        okText={record.status===2?'启用':'禁用'}
                        cancelText="取消"
                    >
                    <span className="showClickDetail" >{record.status===2?'启用':'禁用'}</span>
                    </Popconfirm>
                    <Divider type="vertical" />
                </AuthButton>
                <AuthButton authkey="j-5-4">

                    <span className="showClickDetail" onClick={() => { handleQueryActionRecords(record.id) }}>操作记录</span>
                </AuthButton>
                </React.Fragment>
                    )

        }
    },
];



// WEBPACK FOOTER //
// ./src/page/WftPayChannel/List.js